import { CommonKeys } from "../../../common/enums";
import { MATERIAL_ACTION_NAMES_TYPE, MATERIAL_ACTION_TYPE } from "../../../common/formular-group-types";

export const FormularModelMetaMaterialActionNamesSchema = {
    $id: "FormularModelMetaMaterialActionNamesSchema",
    title: "FormularModelMetaMaterialActionNames Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: MATERIAL_ACTION_NAMES_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: { $ref: "FormularModelMetaMaterialActionSchema" },
            nullable: true
        }
    }
}

export const FormularModelMetaMaterialActionSchema = {
    $id: "FormularModelMetaMaterialActionSchema",
    title: "FormularModelMetaMaterialAction Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: MATERIAL_ACTION_TYPE },
        EnumName: { type: "string" },
        DisplayName: { type: "string" }
    },
    required: [CommonKeys.Type, "EnumName", "DisplayName"]
}